import { GET_OFFER_BY_ID } from "../constants";
import { RequestService } from "../../../../../common/services/RequestService";
import { adjustOfferData } from "./adjustOfferData";

export const getOffer = async (payload, profileId) => {
  const response = await RequestService.get(
    GET_OFFER_BY_ID.replace("{offer_id}", payload).replace(
      "{profile_id}",
      profileId
    )
  );
  return adjustOfferData(response.data);
};
